import React from 'react';
import Modal from 'react-modal';
import { Facebook, Twitter, Embed, Email, Close } from '../util/icons_svg.js';
import { trackClick, trackListTracEvent } from "../util/util.js";

const customStyles = {
    content : {
    },
    overlay : {zIndex: 20002}
};

const copyToClipboard = (text) => {
    const dummy = document.createElement('input');
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);

}

class ShareModal extends React.Component {
    render() {
        const detailUrl = encodeURIComponent(window.location.href);
        const {item, trackingEnabled, isOpen, onRequestClose} = this.props;
        return (
            <Modal
                isOpen={isOpen}
                onRequestClose={onRequestClose}
                style={customStyles}
                className="share-modal"
            >
                <div className="detail-share">
                    <h3>Share this property</h3>
                </div>
                <div className="detail-share-links">
                    <a href={"https://www.facebook.com/sharer/sharer.php?u=" + detailUrl}
                       target="_blank"
                       rel="noopener noreferrer"
                       onClick={() => {
                                   trackClick('dp_sharebar_click', 'sharebar_click: Facebook');
                                   trackListTracEvent(item, trackingEnabled, 'share');
                            }
                       }
                    >
                        <Facebook/>
                    </a>
                    <a href={"http://twitter.com/share?url=" + detailUrl}
                       target="_blank"
                       rel="noopener noreferrer"
                       onClick={() => {
                                    trackClick('dp_sharebar_click', 'sharebar_click: Twitter');
                                    trackListTracEvent(item, trackingEnabled, 'share');
                            }
                       }
                    >
                        <Twitter/>
                    </a>
                    <a href="#"
                        onClick={(e) => {
                                    copyToClipboard(window.document.location);
                                    trackClick('dp_sharebar_click', 'sharebar_click: Embed');
                                    trackListTracEvent(item, trackingEnabled, 'share');
                                    e.preventDefault();
                            }
                        }
                    >
                        <Embed />
                    </a>
                    <a href={"mailto:someone@site.com?subject=I like this property -- have a look&body=" + detailUrl}
                       onClick={() => {
                                    trackClick('dp_sharebar_click', 'sharebar_click: Email');
                                    trackListTracEvent(item, trackingEnabled, 'share');
                            }
                       }
                    >
                        <Email/>
                    </a>
                </div>
                <a className="share-modal-close" onClick={onRequestClose}><Close/></a>
            </Modal>
        )
    }
}

export default ShareModal;
